import React, { useEffect, useState, useRef } from 'react';
import { Collapse, Navbar, Nav } from 'reactstrap';
import classnames from 'classnames';
import Button from 'app/components/general/Button';
import PaymentBadge from 'app/components/general/PaymentBadge';
import StatusBadge from 'app/components/general/StatusBadge';
import ModalConfirm from 'app/components/general/ModalConfirm';
import TeamContainer from './TeamContainer';


interface IEventSidebarProps {
  fixtureMatchDashboardId: string;
  status: string;
  fixtureMatchStatus: string;
  groupOneName: string;
  groupTwoName: string;
  eventDescription: string;
  eventTime: string;
  groupOneMatchPaymentId: string;
  groupTwoMatchPaymentId: string;
  groupOneSubscriptionPaymentId: string;
  groupTwoSubscriptionPaymentId: string;
  groupOnePaymentUrl: string;
  groupTwoPaymentUrl: string;
  groupOnePaymentText: string;
  groupTwoPaymentText: string;
  eventSection: string;
  eventLocation: string;
  id: string;
  reference: string;
  groupOneChecked: boolean;
  groupTwoChecked: boolean;
  isOpen: boolean;
  isLoading: boolean;
  handleSidebarClose: any;
  updatePaymentEvent: any;
  updateSubscriptionPayment: any;
  getPaymentEvent: any;
  subscriptionPayments: any;
}

const EventSidebar = (props: IEventSidebarProps) => {
  const node = useRef();

  const [open, setOpen] = useState(false);

  const handleClickOutside = (e) => {
    if (
      (node.current !== undefined
      && node.current !== null
      && e.target !== null
        && node.current.contains(e.target))
    ) {
      return;
    }
    props.handleSidebarClose();
    setOpen(false);
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchend', handleClickOutside);
    };
  }, [open]);


  return (
    <div ref={node}>
      <Navbar
        className={classnames({
          'event-sidebar': true,
          'd-none': !props.isOpen,
        })}
      >
        <Collapse isOpen={props.isOpen} navbar>
          <Nav className="" navbar>
            {!_.isEmpty(props.groupOneSubscriptionPaymentId) && (
              <TeamContainer
                key={`team-container-${props.groupOneSubscriptionPaymentId}`}
                containerLabel="Team 1"
                fixtureMatchDashboardId={props.fixtureMatchDashboardId}
                groupName={props.groupOneName}
                groupPaymentText={props.groupOnePaymentText}
                groupChecked={props.groupOneChecked}
                handleSidebarClose={props.handleSidebarClose}
                groupPaymentUrl={MANAGER_APP_URL}
                subscriptionPaymentId={props.groupOneSubscriptionPaymentId}
                paymentEventId={props.id}
                paymentData={props.groupOnePaymentData}
                updatePaymentEvent={props.updatePaymentEvent}
                updateSubscriptionPayment={props.updateSubscriptionPayment}
                getPaymentEvent={props.getPaymentEvent}
                loading={props.subscriptionPayments.isLoading}
              />
            )}
            {!_.isEmpty(props.groupTwoSubscriptionPaymentId) && (
              <TeamContainer
                key={`team-container-${props.groupTwoSubscriptionPaymentId}`}
                containerLabel="Team 2"
                fixtureMatchDashboardId={props.fixtureMatchDashboardId}
                groupName={props.groupTwoName}
                groupPaymentText={props.groupTwoPaymentText}
                groupChecked={props.groupTwoChecked}
                handleSidebarClose={props.handleSidebarClose}
                groupPaymentUrl={MANAGER_APP_URL}
                subscriptionPaymentId={props.groupTwoSubscriptionPaymentId}
                paymentEventId={props.id}
                paymentData={props.groupTwoPaymentData}
                updatePaymentEvent={props.updatePaymentEvent}
                updateSubscriptionPayment={props.updateSubscriptionPayment}
                getPaymentEvent={props.getPaymentEvent}
                loading={props.subscriptionPayments.isLoading}
              />
            )}
            <div className="row margin-top">
              <div className="col">
                <div className="card event-sidebar-row-container">
                  <div className="event-sidebar-row">
                    <div className="event-sidebar-row-text">
                      Match
                      <PaymentBadge
                        className="event-card-badge ml-auto"
                        paymentText={props.status}
                      />
                    </div>
                  </div>
                  {props.fixtureMatchStatus !== 'cancelled' && (
                    <Button
                      className="btn-standard btn-2 btn-black w-100"
                      noLoading
                      confirmButton
                      loadingColor="grey"
                      type="submit"
                      onClick={() => {
                        if (props.id !== null) {
                          const payload = {
                            id: props.id,
                            status: 'cancelled',
                          };

                          props.updatePaymentEvent(
                            payload,
                            props.fixtureMatchDashboardId,
                            props.id,
                          );

                          props.handleSidebarClose();
                        }
                      }}
                    >
                      Cancel Match
                    </Button>
                  )}
                  {props.fixtureMatchStatus === 'cancelled' && (
                    <Button
                      className="btn-standard btn-2 btn-grey w-100"
                      noLoading
                      confirmButton
                      loadingColor="grey"
                      type="submit"
                      onClick={() => {
                        if (props.id !== null) {
                          const payload = {
                            id: props.id,
                            status: 'active',
                          };

                          props.updatePaymentEvent(
                            payload,
                            props.fixtureMatchDashboardId,
                            props.id,
                          );

                          props.handleSidebarClose();
                        }
                      }}
                    >
                      Undo Cancel
                    </Button>
                  )}
                </div>
              </div>
            </div>
            <div className="d-block w-100 margin-top-auto h-auto">
              {/* {props.status === 'Cancelled' && (
                <Button
                  className="btn-standard btn-2 btn-outline cancel-button w-100"
                  onClick={handleUndoCancel}
                >
                  Undo Cancel
                </Button>
              )} */}
              {/* {props.status !== 'Cancelled' && (
                <Button
                  className="btn-standard btn-2 btn-outline cancel-button w-100"
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              )} */}
              <Button
                className="btn-standard btn-2 w-100"
                onClick={props.handleSidebarClose}
                noLoading
              >
                Close
              </Button>
            </div>
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  );
};

EventSidebar.defaultProps = {
  status: 'Pending',
  eventDescription: '',
  eventTime: '',
  eventSection: '',
  eventLocation: '',
  groupOneName: '',
  groupTwoName: '',
  reference: '',
  fixtureMatchDashboardId: undefined,
  groupOneMatchPaymentId: undefined,
  groupTwoMatchPaymentId: undefined,
  groupOnePaymentUrl: undefined,
  groupTwoPaymentUrl: undefined,
  groupOnePaymentText: undefined,
  groupTwoPaymentText: undefined,
  id: undefined,
  groupOneChecked: false,
  groupTwoChecked: false,
  isOpen: false,
  handleSidebarClose: undefined,
  updateSubscriptionPayment: undefined,
  getPaymentEvent: undefined,
  matchPayments: {},
};

export default EventSidebar;
